import { useQuery } from "@tanstack/react-query";
import peopleService from "~/services/people";
import { QueryKey } from "~/utils";

type UseDuplicateProfilesExistenceQueryOptions = {
  orgId?: string;
  enabled?: boolean;
};

// Cheap "are there any" check for the sidebar dot: fetch one group and test for any items.
// Keyed under DuplicateProfiles so the merge mutation invalidation refreshes it.
export const useDuplicateProfilesExistenceQuery = ({
  orgId,
  enabled = true,
}: UseDuplicateProfilesExistenceQueryOptions = {}) =>
  useQuery({
    queryKey: [QueryKey.DuplicateProfiles, orgId, "existence"],
    queryFn: () =>
      peopleService.findDuplicateProfiles(orgId as string, { perPage: 1, matchFields: ["familyName", "email"] }),
    select: (data) => data.items.length > 0,
    enabled: enabled && !!orgId,
  });
